const links = [
  { label: "Resident Perks", href: "#perks", id: "nav-link-perks" },
  { label: "Pricing", href: "#pricing", id: "nav-link-pricing" },
  { label: "Gallery", href: "#gallery", id: "nav-link-gallery" },
];

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-[#f8f3e9]/95 backdrop-blur-md border-b border-[#00334a]/10"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 sm:px-8 py-3">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center">
          <img
            src="/logo-horizontal.png"
            alt="Little Splash Swim Program"
            className="h-9 sm:h-10 w-auto"
          />
        </a>
        <nav className="hidden md:flex items-center gap-8" data-testid="site-nav">
          {links.map((l) => (
            <a
              key={l.id}
              data-testid={l.id}
              href={l.href}
              className="text-sm font-medium text-[#00334a]/70 hover:text-[#c97049] transition-colors duration-300 underline-offset-4 hover:underline"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <span
          data-testid="nav-resident-badge"
          className="hidden sm:inline-flex items-center rounded-full bg-[#ddc0a6] px-3.5 py-1.5 text-xs font-semibold tracking-wide text-[#00334a]"
        >
          Four Seasons Residents Only
        </span>
      </div>
    </header>
  );
}
